/**
 * @ngdoc service
 * @name CustomFileUploader
 *
 * @description
 * Service used to upload files
 */
module.factory('CustomFileUploader',  ['FileUploader', function (FileUploader) {
    CustomFileUploader.prototype = FileUploader.prototype;
    CustomFileUploader.super_ = FileUploader;

    function CustomFileUploader(options) {
        CustomFileUploader.super_.apply(this, arguments);
    }

    return CustomFileUploader;
}]);